import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import swal from "sweetalert";

import "./style.scss";
import {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
} from "../../AdminMentorAction/dependencies/action";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Modal } from "react-bootstrap";
import clsx from "clsx";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  Divider,
  InputBase,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
  Tooltip,
  Typography,
  Grid,
} from "@material-ui/core";
import useStyles from "./style";
import "@fontsource/montserrat";
import { TextInput } from "../textInput";
import Fuse from "fuse.js";
import SearchRounded from "@material-ui/icons/SearchRounded";
import { MATCH_GROUP_MESSAGES } from "../../../../../common/constants/ApplicationUrl";
import api from "../../../../../common/dependencies/utils/Api";

const CustomModal = (props) => {
  const classes = useStyles();
  const { modalOpen } = props;

  const [error, setError] = useState();
  const [groupName, setGroupName] = useState();
  const [groupTitle, setgroupTitle] = useState();

  // useEffect(() => {

  // }, []);

  useEffect(() => {
    props.setTaggingList([]);
  }, [modalOpen]);

  const checkboxRef = useRef([]);
  const checkboxRef2 = useRef([]);

  useEffect(() => {
    checkboxRef.current = checkboxRef.current.slice(
      0,
      props.allCohortMentors?.length
    );
    checkboxRef2.current = checkboxRef2.current.slice(
      0,
      props.allCohortStartups?.length
    );
  }, [props.allCohortMentors]);

  const handleSubmit = () => {};
  const handleClose = () => {
    props.setModalOpen(false);
  };

  const [searchTooltipOpen, setSearchTooltipOpen] = useState(false);
  const [searchContent, setSearchContent] = useState();
  const [searchList, setSearchList] = useState([]);
  const [searchStartupTooltipOpen, setSearchStartupTooltipOpen] =
    useState(false);
  const [searchStartupContent, setSearchStartupContent] = useState();
  const [searchStartupList, setSearchStartupList] = useState([]);

  useEffect(() => {
    if (!searchContent) {
      setSearchTooltipOpen(false);
    } else {
      setSearchTooltipOpen(true);
    }
  }, [searchContent]);

  useEffect(() => {
    if (!searchStartupContent) {
      setSearchStartupTooltipOpen(false);
    } else {
      setSearchStartupTooltipOpen(true);
    }
  }, [searchStartupContent]);

  const sendMessageNow = () => {
    let value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

    const formData = new FormData();
    formData.append(
      "message",
      JSON.stringify({
        senderId: value?.id,
        senderName: value.name,
        groupSubject: groupTitle,
        cohortId: props.newCohortId,
        message: {
          commentByUserId: value?.id,
          commentedByUserRole: value.role,
          text: props.inputValue,
        },
        taggingList: props.taggingList,
      })
    );
    if (props.file) {
      formData.append("commentFile", props.file, props.file?.name);
    }

    // axios({
    //   url: MATCH_GROUP_MESSAGES,
    //   method: "post",
    //   data: formData,
    // })
    api
      .POST(MATCH_GROUP_MESSAGES, formData)
      .then((res) => {
        // setGroupmessages(res.data?.data);
        swal("Thank you", " Message Sent Successfully.", "success", {
          closeOnClickOutside: false,
          buttons: {
            closemodal: {
              text: "OK",
            },
          },
        }).then((value) => {
          switch (value) {
            case "closemodal":
              // window.location.reload();
              props.setModalOpen(false);

              setTimeout(() => {
                setgroupTitle(null);
                props.setInputValue(null);
                // props.setTaggingList(null);
              }, 1000);

              break;
            default:
          }
        });
      })

      .catch((err) => {});
  };

  return (
    <Modal
      size="lg"
      show={props.modalOpen}
      onHide={() => props.setModalOpen(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      style={{ borderRadius: "7px" }}
      className="sendcohortgroupmsgcohortgroupmodalmobile"
    >
      <Modal.Header className="d-flex ">
        <Modal.Title className="modalHeading d-flex justify-content-center">
          SEND COHORT GROUP MESSAGE
        </Modal.Title>
        <div className="newuserTooltip">
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          />
          <span
            className="tooltiptext  close-window"
            style={{ left: "-150px", top: "2px", width: "130px" }}
          >
            Close Window
          </span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Paper elevation={0} className={classes.listContainer}>
          <Typography
            className={classes.goalLabel}
            style={{ marginBottom: "20px", fontSize: "16px" }}
          >
            Select from list of Mentors and Startups to whom you wish to send
            this message.
          </Typography>
          <Grid
            item
            xs={12}
            style={{
              paddingRight: "5px",
            }}
          >
            <h6
              style={{
                fontFamily: "Montserrat",
                fontSize: "16px",
                width: "100%",
                padding: "5px 10px 0 3px",
                fontWeight: "300",
                color: "#6e6e6e",
                margin: "5px 0px 5px 0px",
              }}
            >
              Enter Group Title
            </h6>
            <Box
              style={{
                border: "1px solid rgba(0,0,0,0.3)",
                borderRadius: "4px",
                display: "flex",
              }}
            >
              <InputBase
                InputLabelProps={{
                  shrink: true,
                }}
                value={groupTitle}
                onChange={(e) => {
                  setgroupTitle(e.target.value);
                }}
                style={{
                  fontFamily: "Montserrat",
                  // fontWeight: "no",
                  fontSize: "16px",
                  color: "rgba(0,0,0,0.5)",
                  width: "100%",
                  padding: "5px 10px",
                }}
              />
            </Box>
          </Grid>
          <Box
            className={classes.flexAcross}
            style={{ justifyContent: "space-between" }}
          >
            <Box className={classes.flexAcrossWidth}>
              <Tooltip
                open={searchTooltipOpen}
                interactive
                classes={{
                  tooltip: classes.tooltip,
                  tooltipArrow: classes.tooltipArrow,
                }}
                PopperProps={{
                  disablePortal: true,
                }}
                arrow
                title={
                  <>
                    <ClickAwayListener
                      onClickAway={() => setSearchTooltipOpen(false)}
                    >
                      <Paper
                        elevation={4}
                        style={{
                          padding: "15px",
                          height: "300px",
                          width: "400px",
                          overflowY: "scroll",
                        }}
                      >
                        {searchList?.map((item) => (
                          <>
                            <ListItem alignItems="center">
                              <ListItemSecondaryAction>
                                <Checkbox
                                  edge="end"
                                  checked={props.taggingList.includes(item.id)}
                                  classes={{
                                    root: classes.checkboxRoot,
                                  }}
                                  onChange={(e) => {
                                    const index =
                                      props.allCohortMentors?.findIndex(
                                        (ele) => ele.id === item.id
                                      );
                                    if (index >= 0) {
                                      checkboxRef.current[index].click();
                                    }
                                    props.onBroadcastSelectionChange(
                                      item,
                                      e.target.checked
                                    );
                                  }}
                                />
                              </ListItemSecondaryAction>
                              <ListItemAvatar>
                                <Avatar
                                  classes={{
                                    img: classes.objectFit,
                                  }}
                                  src={item.image}
                                ></Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary={
                                  <>
                                    <Typography
                                      style={{
                                        fontFamily: "Montserrat",
                                        fontSize: "16px",
                                      }}
                                    >
                                      {item?.name}
                                    </Typography>
                                  </>
                                }
                              />
                            </ListItem>
                            <Divider
                              variant="inset"
                              style={{ height: "2px" }}
                            />
                          </>
                        ))}
                      </Paper>
                    </ClickAwayListener>
                  </>
                }
              >
                <Box style={{ position: "relative" }}>
                  <SearchRounded
                    style={{
                      position: "absolute",
                      left: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "rgba(0,0,0,0.3)",
                    }}
                  />
                  <InputBase
                    fullWidth
                    placeholder="Search Mentors"
                    value={searchContent}
                    className={classes.searchField}
                    onChange={(e) => {
                      setSearchContent(e.target.value);
                      const fuse = new Fuse(props.allCohortMentors, {
                        keys: ["name"],
                        threshold: 0.1,
                      });
                      const matches = fuse.search(e.target.value);
                      const results = matches.map((item) => item.item);
                      setSearchList(results);
                    }}
                  />
                </Box>
              </Tooltip>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "0 20px",
                }}
                className="sndbrdcastmsgslctall"
              >
                <Typography className={classes.goalLabel3} style={{ flex: 1 }}>
                  TOTAL MENTORS: {props.allCohortMentors?.length}
                </Typography>

                <Typography className={classes.goalLabel3}>
                  Select All
                </Typography>
                <Checkbox
                  classes={{
                    root: classes.checkboxRoot,
                  }}
                  onChange={(e) => {
                    if (e.target.checked) {
                      props.allCohortMentors?.forEach((item, i) => {
                        if (!checkboxRef.current[i].checked) {
                          checkboxRef.current[i].click();
                        }
                      });
                      props.setTaggingList([
                        ...props.taggingList,
                        ...props.allCohortMentors
                          ?.filter((ite) => {
                            let isThere = true;
                            props.taggingList.forEach((i) => {
                              if (i === ite.id) {
                                isThere = false;
                              }
                            });
                            return isThere;
                          })
                          .map((ite) => ite.id),
                        // ...props.allMentorList?.map((item) => item.id),
                      ]);
                    } else {
                      props.allCohortMentors?.forEach((item, i) => {
                        if (checkboxRef.current[i].checked) {
                          checkboxRef.current[i].click();
                        }
                      });
                      props.setTaggingList(
                        props.taggingList.filter((item) => {
                          let isThere = true;
                          props.allCohortMentors?.forEach((innerItem) => {
                            if (item === innerItem.id) isThere = false;
                          });
                          return isThere;
                        })
                      );
                    }
                  }}
                />
              </Box>
              <Typography
                className={clsx(classes.goalLabel3, "selectednumberalign")}
                style={{
                  textAlign: "right",
                  // marginRight: "40px"
                }}
              >
                Selected:{" "}
                {
                  props.taggingList.filter((item) => {
                    let isThere = false;
                    props.allCohortMentors?.forEach((i) => {
                      if (item === i.id) {
                        isThere = true;
                      }
                    });
                    return isThere;
                  }).length
                }
              </Typography>
              <Box className={classes.listOverflow}>
                <List className={classes.list}>
                  {props.allCohortMentors?.map((datum, index) => (
                    <>
                      <ListItem alignItems="center">
                        <ListItemSecondaryAction>
                          <Checkbox
                            edge="end"
                            inputRef={(el) => (checkboxRef.current[index] = el)}
                            classes={{
                              root: classes.checkboxRoot,
                            }}
                            onChange={(e) => {
                              props.onBroadcastSelectionChange(
                                datum,
                                e.target.checked
                              );
                            }}
                          />
                        </ListItemSecondaryAction>
                        <ListItemAvatar>
                          <Avatar
                            classes={{
                              img: classes.objectFit,
                            }}
                            src={datum.image}
                          ></Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <>
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "16px",
                                }}
                              >
                                {datum?.name}
                              </Typography>
                            </>
                          }
                        />
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </>
                  ))}
                </List>
              </Box>
            </Box>
            <Box className={classes.flexAcrossWidth}>
              <Tooltip
                open={searchStartupTooltipOpen}
                interactive
                classes={{
                  tooltip: classes.tooltip,
                  tooltipArrow: classes.tooltipArrow,
                }}
                PopperProps={{
                  disablePortal: true,
                }}
                arrow
                title={
                  <>
                    <ClickAwayListener
                      onClickAway={() => setSearchStartupTooltipOpen(false)}
                    >
                      <Paper
                        elevation={4}
                        style={{
                          padding: "15px",
                          height: "300px",
                          width: "400px",
                          overflowY: "scroll",
                        }}
                      >
                        {searchStartupList?.map((item) => (
                          <>
                            <ListItem alignItems="center">
                              <ListItemSecondaryAction>
                                <Checkbox
                                  edge="end"
                                  classes={{
                                    root: classes.checkboxRoot,
                                  }}
                                  checked={props.taggingList.includes(item.id)}
                                  onChange={(e) => {
                                    const index =
                                      props.allCohortStartups?.findIndex(
                                        (ele) => ele.id === item.id
                                      );
                                    if (index >= 0) {
                                      checkboxRef2.current[index].click();
                                    }
                                    props.onBroadcastSelectionChange(
                                      item,
                                      e.target.checked
                                    );
                                  }}
                                />
                              </ListItemSecondaryAction>
                              <ListItemAvatar>
                                <Avatar
                                  classes={{
                                    img: classes.objectFit,
                                  }}
                                  src={item.image}
                                ></Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary={
                                  <>
                                    <Typography
                                      style={{
                                        fontFamily: "Montserrat",
                                        fontSize: "16px",
                                      }}
                                    >
                                      {item?.name}
                                    </Typography>
                                  </>
                                }
                              />
                            </ListItem>
                            <Divider
                              variant="inset"
                              style={{ height: "2px" }}
                            />
                          </>
                        ))}
                      </Paper>
                    </ClickAwayListener>
                  </>
                }
              >
                <Box style={{ position: "relative" }}>
                  <SearchRounded
                    style={{
                      position: "absolute",
                      left: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "rgba(0,0,0,0.3)",
                    }}
                  />
                  <InputBase
                    fullWidth
                    placeholder="Search Startups"
                    value={searchStartupContent}
                    className={classes.searchField}
                    onChange={(e) => {
                      setSearchStartupContent(e.target.value);
                      const fuse = new Fuse(props.allCohortStartups, {
                        keys: ["name"],
                        threshold: 0.1,
                      });
                      const matches = fuse.search(e.target.value);
                      const results = matches.map((item) => item.item);
                      setSearchStartupList(results);
                    }}
                  />
                </Box>
              </Tooltip>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "0 20px",
                }}
                className="sndbrdcastmsgslctall"
              >
                <Typography className={classes.goalLabel3} style={{ flex: 1 }}>
                  TOTAL STARTUPS: {props.allCohortStartups?.length}
                </Typography>

                <Typography className={classes.goalLabel3}>
                  Select All
                </Typography>
                <Checkbox
                  classes={{
                    root: classes.checkboxRoot,
                  }}
                  onChange={(e) => {
                    if (e.target.checked) {
                      props.allCohortStartups?.forEach((item, i) => {
                        if (!checkboxRef2.current[i].checked) {
                          checkboxRef2.current[i].click();
                        }
                      });
                      props.setTaggingList([
                        ...props.taggingList,
                        ...props.allCohortStartups
                          ?.filter((ite) => {
                            let isThere = true;
                            props.taggingList.forEach((i) => {
                              if (i === ite.id) {
                                isThere = false;
                              }
                            });
                            return isThere;
                          })
                          .map((ite) => ite.id),
                        // ...props.allStartupList?.map((item) => item.id),
                      ]);
                    } else {
                      props.allCohortStartups?.forEach((item, i) => {
                        if (checkboxRef2.current[i].checked) {
                          checkboxRef2.current[i].click();
                        }
                      });
                      props.setTaggingList(
                        props.taggingList.filter((item) => {
                          let isThere = true;
                          props.allCohortStartups?.forEach((innerItem) => {
                            if (item === innerItem.id) isThere = false;
                          });
                          return isThere;
                        })
                      );
                    }
                  }}
                />
              </Box>
              <Typography
                className={clsx(classes.goalLabel3, "selectednumberalign")}
                style={{
                  textAlign: "right",
                  //  marginRight: "40px"
                }}
              >
                Selected:{" "}
                {
                  props.taggingList.filter((item) => {
                    let isThere = false;
                    props.allCohortStartups?.forEach((i) => {
                      if (item === i.id) {
                        isThere = true;
                      }
                    });
                    return isThere;
                  }).length
                }
              </Typography>
              <Box className={classes.listOverflow}>
                <List className={classes.list}>
                  {props.allCohortStartups?.map((datum, index) => (
                    <>
                      <ListItem alignItems="center">
                        <ListItemSecondaryAction>
                          <Checkbox
                            edge="end"
                            classes={{
                              root: classes.checkboxRoot,
                            }}
                            inputRef={(el) =>
                              (checkboxRef2.current[index] = el)
                            }
                            onChange={(e) => {
                              props.onBroadcastSelectionChange(
                                datum,
                                e.target.checked
                              );
                            }}
                          />
                        </ListItemSecondaryAction>
                        <ListItemAvatar>
                          <Avatar
                            classes={{
                              img: classes.objectFit,
                            }}
                            src={datum.image}
                          ></Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <>
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "16px",
                                  paddingRight: "40px",
                                }}
                              >
                                {datum?.name}
                              </Typography>
                            </>
                          }
                        />
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </>
                  ))}
                </List>
              </Box>
            </Box>
          </Box>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-around",
              padding: "25px 0",
              width: "100%",
            }}
          >
            <TextInput
              props={props}
              onAttachFile={props.onAttachFile}
              sendMessageNow={sendMessageNow}
              setInputValue={props.setInputValue}
              inputValue={props.inputValue}
              file={props.file}
            />
          </Box>
        </Paper>
      </Modal.Body>
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
})(withRouter(CustomModal));
